<template lang="pug">
  include ../pug/mixin/content.pug

  header.header#header(:style="isHomePage ? 'overflow-x: hidden' : ''", v-cloak :class="isHomePage ? '' : 'header--white'")
      MobileMenu( :dark="isHomePage" )

      Nav( :dark="isHomePage" :authBlock="!isHomePage" )

      .header__container( v-show="isHomePage" )
          .header__mobile-menu

              Logo( :white="isHomePage" )
              <button class="hamburger hamburger--slider" type="button">
                  <span class="hamburger-box">
                      <span class="hamburger-inner"></span>
                  </span>
              </button>

          .header__content
              .header__title
                  span(v-html="tr.title")
              .header__mobile-img
                  img(v-if="lang_switips === 'ru'" src=`@/assets/images/mac_mobile_ru.png`, alt="")
                  img(v-if="lang_switips === 'en'" src=`@/assets/images/mac_mobile_en.png`, alt="")
                  img(v-if="lang_switips === 'es'" src=`@/assets/images/mac_mobile_en.png`, alt="")
                  img(v-if="lang_switips === 'kz'" src=`@/assets/images/mac_mobile_kz.png`, alt="")
                  img(v-if="lang_switips === 'ua'" src=`@/assets/images/mac_mobile_ua.png`, alt="")
              .header__dsc
                  span(v-html="tr.dsc")
              .header__authorizations
                  AuthBlock( dark large )

          img.header__img(v-if="lang_switips === 'ru'" src=`@/assets/images/header_ru.png`, alt="")
          img.header__img(v-if="lang_switips === 'en'" src=`@/assets/images/header_en.png`, alt="")
          img.header__img(v-if="lang_switips === 'es'" src=`@/assets/images/header_en.png`, alt="")
          img.header__img(v-if="lang_switips === 'kz'" src=`@/assets/images/header_ru.png`, alt="")
          img.header__img(v-if="lang_switips === 'ua'" src=`@/assets/images/header_ru.png`, alt="")

      .is( v-if="!isHomePage" )
        .container
          .header__mobile-menu.mobile-menu_p_40
            Logo.main-logo
            <button class="hamburger hamburger--slider hamburger_color_main" type="button" @click="">
                <span class="hamburger-box">
                    <span class="hamburger-inner"></span>
                </span>
            </button>
</template>
<script>
import isHomePage from '../mixins/isHomePage'

import Nav from './parts/Nav'
import AuthBlock from './parts/AuthBlock'
import Logo from './parts/Logo'
import MobileMenu from './parts/MobileMenu'
import langOps from '@/mixins/langOps'

export default {
  data () {
    return {
      section: 'header'
    }
  },
  mixins: [isHomePage, langOps],
  components: {
    Nav,
    AuthBlock,
    Logo,
    MobileMenu
  }
}
</script>

<style lang="scss">
  .header {

    min-height: 600px;

    //background: $main_color;
    // Для Нового Года
    background: #ff6e00;
    &--white {
      min-height: initial;
      background: #fff;
      padding-bottom: .8rem;
    }

    &__container {
      box-sizing: border-box;
      display: flex;

      min-width: 1280px;
      justify-content: space-between;

      margin-top: 100px;
      padding-left: 180px;
      padding-bottom: 125px;

      @media (max-width: 1024px) {
        flex-direction: column;

        min-width: 0;
        margin-top: 0;
        padding-top: 20px;
        padding-left: 20px;
        padding-right: 20px;
        padding-bottom: 65px;
      }
    }

    &__mobile-menu {
      display: none;

      @media (max-width: 1024px) {
        display: flex;
        justify-content: space-between;
        align-items: center;

        margin-bottom: 40px;
      }
    }

    &__content {
      display: flex;
      flex-direction: column;
      width: 100%;
    }

    &__title {
      margin-bottom: 33px;

      font-size: $fz_xl;
      color: $second_color;
      line-height: 1.2;
      letter-spacing: 0.5px;

      @media (max-width: 480px) {
        font-size: 27px;
      }
    }

    &__mobile-img {
      display: none;

      @media (max-width: 1024px) {
        display: block;
        margin-bottom: 40px;
        margin-left: auto;
        margin-right: auto;
        img{
          max-width: 100%;
        }
      }
    }

    &__dsc {
      margin-bottom: 48px;

      font-size: $fz_s;
      color: $second_color;
      line-height: 1.5;
      letter-spacing: 0.2px;

      @media (max-width: 1024px) {

      }
    }

    &__img {
      height: 379px;
      @media (max-width: 1024px) {
        display: none;
      }
    }
  }

  .hamburger {
    padding: 10px -1px;
    z-index: 101;
    background-color: #000!important;
    border-radius: 4px;

    &_color_main {
      background: $main_color;
    }

    &_color_black {
      background-color: #000!important;
    }
  }

  .hamburger-box {
    width: 32px;
  }

  .hamburger-inner, .hamburger-inner::before, .hamburger-inner::after {
    background-color: #fff!important;
    height: 3px;
    width: 32px;
  }

  .hamburger--slider .hamburger-inner {
    top: 6px;
  }
</style>
